import { Dangerous, EmojiEvents } from '@mui/icons-material';
import { Box, Card, List, ListItem, ListItemIcon, ListItemText, SxProps } from '@mui/material';
import { red, teal } from '@mui/material/colors';
import React from 'react';
import { SquareChip } from '../chip/TypeChip';
import PolarityBar from '../polarity-bar/PolarityBar';
import { AssessmentScenario, AssessmentScore, ScenarioType } from '../types';

export interface AssessmentScenariosProps {
  inProgress: boolean;
  scenarios: AssessmentScenario[];
  sx?: SxProps;
}

const numberFormat = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

const foregroundColorMap = type =>
  ({
    [AssessmentScore.Negative]: red[400],
    [AssessmentScore.Positive]: teal[400],
  }[type]);

const AssessmentScenarios = ({ inProgress, scenarios, sx = {} }: AssessmentScenariosProps) => (
  <Card sx={sx}>
    <List sx={{ py: 0 }}>
      <ListItem divider>
        <ListItemText primaryTypographyProps={{ sx: { fontWeight: 'bold' } }}>
          {inProgress ? 'Scenarios' : 'Results'}
        </ListItemText>
      </ListItem>
      {scenarios.map((scenario, i) => (
        <ListItem key={i} divider={scenarios.length - 1 > i}>
          <ListItemIcon
            sx={{
              color: foregroundColorMap(
                scenario.score > 0
                  ? AssessmentScore.Positive
                  : scenario.score < 0
                  ? AssessmentScore.Negative
                  : scenario?.type === ScenarioType.Achievement && scenario?.achievedCount > 0
                  ? AssessmentScore.Positive
                  : scenario?.type === ScenarioType.Error && scenario?.achievedCount > 0
                  ? AssessmentScore.Negative
                  : undefined,
              ),
            }}
          >
            {
              {
                [ScenarioType.Achievement]: <EmojiEvents />,
                [ScenarioType.Error]: <Dangerous />,
              }[scenario?.type]
            }
          </ListItemIcon>
          <ListItemText primary={scenario.name} primaryTypographyProps={{ color: 'text.secondary' }} />

          <PolarityBar
            percentage={scenario.scorePercent}
            type={scenario.score > 0 ? 'positive' : 'negative'}
            sx={{ mr: 2.5, width: '200px' }}
          />
          <Box sx={{ minWidth: 50, display: 'flex', justifyContent: 'end' }}>
            <SquareChip
              label={numberFormat.format(Math.abs(scenario.score))}
              size="small"
              type={
                scenario.score > 0
                  ? AssessmentScore.Positive
                  : scenario.score < 0
                  ? AssessmentScore.Negative
                  : undefined
              }
            />
          </Box>
        </ListItem>
      ))}
    </List>
  </Card>
);

export default AssessmentScenarios;
